import type { TRANSLATED_ROUTE_TYPES } from "@/i18n/translations"

/**
 * Routes & segements
 */

export const ROUTE_SEGMENTS = {
    categories: "categories",
    product: "product",
    journal: "journal",
    cart: "cart",
    checkout: "checkout",
    pressroom: "pressroom",
    discover: "discover"
} as const

export type RouteSegment = (typeof ROUTE_SEGMENTS)[keyof typeof ROUTE_SEGMENTS]
export type TranslatedRoutesKey = keyof typeof TRANSLATED_ROUTE_TYPES

/**
 * Page Types
 */

export const PAGE_TYPE = {
    product: "product",
    category: "category",
    journal: "journal",
    pressroom: "pressroom",
    discover: "discover",
    contentPage: "contentPage",
    newCategoryPage: "newCategoryPage"
} as const

export const SANITY_PAGE_TYPE = {
    contentPage: PAGE_TYPE.contentPage,
    newCategoryPage: PAGE_TYPE.newCategoryPage,
    article: "article",
    pressroomArticle: "pressroomArticle",
    discoverPage: "discoverPage",
    discoverSection: "discoverSection"
} as const

export const DETECTED_PAGE_TYPE = {
    ...SANITY_PAGE_TYPE,
    product: "product"
} as const

export type PageType = (typeof PAGE_TYPE)[keyof typeof PAGE_TYPE]
export type SanityPageType = (typeof SANITY_PAGE_TYPE)[keyof typeof SANITY_PAGE_TYPE]
export type DetectedPageType =
    (typeof DETECTED_PAGE_TYPE)[keyof typeof DETECTED_PAGE_TYPE]
export type CmsPageSitemapType =
    | Extract<PageType, "journal" | "pressroom" | "discover">
    | "content"
